import * as RadixTooltip from "@radix-ui/react-tooltip"
import clsx from "clsx"
import { useEffect, useState } from "react"

import styles from "./Tooltip.module.scss"
import { TooltipProps } from "./Tooltip.types"

export default function Tooltip(props: TooltipProps) {
    const {
        body,
        isDisabled = false,
        isOpen: controlledIsOpen,
        onOpenChange = () => null,
        invertedColors = true,
        defaultPlacement,
        wrapChildren = true,
        children,
        textAlignment = "center",
        sideOffset = 4,
    } = props

    const [isTooltipOpen, setIsTooltipOpen] = useState(false)

    useEffect(() => {
        if (typeof controlledIsOpen === "boolean") {
            setIsTooltipOpen(controlledIsOpen)
        }
    }, [controlledIsOpen])

    useEffect(() => {
        if (isTooltipOpen !== undefined) {
            onOpenChange?.(isTooltipOpen)
        }
    }, [isTooltipOpen])

    if (isDisabled) {
        return <>{children}</>
    } else {
        return (
            <RadixTooltip.Provider>
                <RadixTooltip.Root open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
                    <RadixTooltip.Trigger asChild={true}>
                        {wrapChildren ? <div>{children}</div> : children}
                    </RadixTooltip.Trigger>

                    <RadixTooltip.Portal>
                        <RadixTooltip.Content
                            side={defaultPlacement}
                            sideOffset={sideOffset}
                            className={clsx(
                                styles.base,
                                { [styles.inverted]: invertedColors },
                                styles[`${textAlignment}Text`],
                            )}
                        >
                            {body}
                            <RadixTooltip.Arrow width={8} height={4} className={styles.arrow} />
                        </RadixTooltip.Content>
                    </RadixTooltip.Portal>
                </RadixTooltip.Root>
            </RadixTooltip.Provider>
        )
    }
}
